module.exports = __webpack_public_path__ + "img/freestyle.1d31e219.png";